/**
 * Sunday state: what follows a visitor from page to page (bed size, pincode, the person the fit is for).
 * Kept in this browser only. If storage is blocked, the site still works; it just forgets.
 */

const KEY = 'sunday-state-v1';
let state = {};
try {
  state = JSON.parse(localStorage.getItem(KEY) || '{}') || {};
} catch (e) {
  state = {};
}

export function get(key) {
  return state[key];
}

export function set(key, value) {
  state[key] = value;
  try {
    localStorage.setItem(KEY, JSON.stringify(state));
  } catch (e) {
    /* private mode or blocked storage: keep going in memory */
  }
  document.dispatchEvent(new CustomEvent('sunday:state', { detail: { key, value } }));
}

/**
 * The person the fit numbers are for: { g, age, build, pos }. Carried across pages so every
 * page shows the same Spine fit for the same person. Only the person and the size are kept:
 * never a basket (the Shopify cart is the only basket).
 */
const DEFAULT_PERSON = { g: 'f', age: '40', build: 'n', pos: 'side' };
export function person() {
  const p = state.person;
  return p && typeof p === 'object' ? { ...DEFAULT_PERSON, ...p } : { ...DEFAULT_PERSON };
}
export function setPerson(patch) {
  set('person', { ...person(), ...patch });
}
